<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>

         <v-card>
            <v-card-title>Renewal Payment Status</v-card-title>
            <v-card-text>
               <v-alert :type="alertType" dense text>
                  {{ statusMessage }}
               </v-alert>

               <v-simple-table dense>
                  <template v-slot:default>
                     <tbody>
                        <tr>
                           <th class="text-left">Renewal Year</th>
                           <td>{{ theyear || '-' }}</td>
                        </tr>
                        <tr>
                           <th class="text-left">CPD Points</th>
                           <td>{{ totalcpd || 0 }}</td>
                        </tr>
                        <tr>
                           <th class="text-left">Transaction No.</th>
                           <td>{{ billcode || '-' }}</td>
                        </tr>
                     </tbody>
                  </template>
               </v-simple-table>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="primary" href="/member/payments">Back to Payments</v-btn>
            </v-card-actions>
         </v-card>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'

export default {
   name: "MOMMemberRenewalThankyou",
   components: {
      DashboardLayout,
      BaseBreadcrumb,
   },
   props: {
      theyear: { type: [String, Number], default: '' },
      totalcpd: { type: [String, Number], default: 0 },
      billcode: { type: [String, Number], default: '' },
      status_id: { type: [String, Number], default: null },
   },
   data() {
      return {
         page: { title: "Renewal Payment Status" },
         breadcrumbs: [
            { text: "Dashboard", disabled: false, to: "/dashboard" },
            { text: "Membership Payments", disabled: false, to: "/member/payments" },
            { text: "Payment Status", disabled: true },
         ],
      }
   },
   computed: {
      alertType() {
         if (String(this.status_id) === '1') return 'success'
         if (String(this.status_id) === '3' || !this.status_id) return 'error'
         return 'info'
      },
      statusMessage() {
         if (String(this.status_id) === '1') return 'Payment successful. Your membership renewal has been recorded.'
         if (String(this.status_id) === '3' || !this.status_id) return 'Payment was not completed. Please try again from the Payments page.'
         return 'Payment is pending. Please wait for confirmation.'
      },
   },
}
</script>
